<app-navbar></app-navbar>
<div class="dashboard-full-width">
    <div class="">
        <div class="main-container-dashboard">


            <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->


            <div class="dashboard-container-right">
                <div class="main-container">
                    <div class="row">
                        <div class="card shadow custom-margin-right-box" style="width: 100%">
                            <div class="card-header ">
                                <h4>Change Password</h4>
                            </div>
                            <div class="card-body">

                                <div class="col-lg-12 ">

                                    <div class="justify-content-center ">
                                        <form [formGroup]="changePasswordForm"
                                            (ngSubmit)="onSubmit(changePasswordForm.value)">
                                            <div class="row" autocomplete="off">


                                                <div class="col-md-6">
                                                    <label class="form-label">Current Password<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>
                                                    <input [type]="fieldTextType1 ? 'text' : 'password'" class="form-control" id="currentPassword"
                                                        maxlength="15" formControlName="currentPassword"
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; changePasswordForm.controls.currentPassword.errors }"
                                                        placeholder="Current Password">

                                                        <div class="input-group-append eye-password">
                                                            <div class="input-group-text eye-position-2">
                                                              <span class="fa" [ngClass]="{
                                                                'fa-eye': !fieldTextType1,
                                                                'fa-eye-slash': fieldTextType1
                                                              }"
                                                              (click)="toggleFieldTextType1()">
                                                            </span>
                                                            </div>
                                                          </div>

                                                    <div *ngIf="submitted &amp;&amp; changePasswordForm.controls.currentPassword.errors"
                                                        class="form-text text-danger">
                                                        <div
                                                            *ngIf="changePasswordForm.controls.currentPassword.errors.required">
                                                            Current Password is required</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">New Password<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>
                                                    <input [type]="fieldTextType2 ? 'text' : 'password'"  class="form-control" id="newPassword"
                                                        maxlength="15" formControlName="newPassword"
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; changePasswordForm.controls.newPassword.errors }"
                                                        placeholder="New password">

                                                        <div class="input-group-append eye-password">
                                                            <div class="input-group-text eye-position-2">
                                                              <span class="fa" [ngClass]="{
                                                                'fa-eye': !fieldTextType2,
                                                                'fa-eye-slash': fieldTextType2
                                                              }"
                                                              (click)="toggleFieldTextType2()">
                                                            </span>
                                                            </div>
                                                          </div>

                                                    <div *ngIf="submitted &amp;&amp; changePasswordForm.controls.newPassword.errors"
                                                        class="form-text text-danger">
                                                        <div
                                                            *ngIf="changePasswordForm.controls.newPassword.errors.required">
                                                            New Password is required</div>
                                                        <div *ngIf="changePasswordForm.controls.newPassword.errors.pattern">
                                                            New Password must be combination of below:<br>Must be 8 Character Long<br>1 Upper Case [A-Z] <br> 1 Lower Case [a-z] <br>1 Digit [0-9] <br>1 Special Character ?=.*?[#?!@$%^&*-]
                                                        </div>


                                                        <div
                                                            *ngIf="changePasswordForm.controls.newPassword.errors.maxlength">
                                                            Password
                                                            must be under
                                                            8 characters</div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <label class="form-label">Confirm New Password<sup
                                                            class="ml-1 font-weight-bolder text-danger">*</sup></label>
                                                    <input [type]="fieldTextType3 ? 'text' : 'password'"  class="form-control"
                                                        formControlName="confirmNewPassword" placeholder="Confirm New Password"
                                                        [ngClass]="{ 'is-invalid': submitted &amp;&amp; changePasswordForm.controls.confirmNewPassword.errors }">

                                                        <div class="input-group-append eye-password">
                                                            <div class="input-group-text eye-position-2">
                                                              <span class="fa" [ngClass]="{
                                                                'fa-eye': !fieldTextType3,
                                                                'fa-eye-slash': fieldTextType3
                                                              }"
                                                              (click)="toggleFieldTextType3()">
                                                            </span>
                                                            </div>
                                                          </div>

                                                    <div *ngIf="submitted &amp;&amp; changePasswordForm.controls.confirmNewPassword.errors"
                                                        class="form-text text-danger">
                                                        <div
                                                            *ngIf="changePasswordForm.controls.confirmNewPassword.errors.required">
                                                            Confirm New Password is
                                                            required</div>
                                                        <div *ngIf="changePasswordForm.controls.confirmNewPassword.errors.maxlength">
                                                            New Password must be combination of below:<br>1 Upper Case [A-Z] <br> 1 Lower Case [a-z] <br>1 Digit [0-9] <br>1 Special Character ?=.*?[#?!@$%^&*-]
                                                        </div>

                                                        <div
                                                            *ngIf="changePasswordForm.controls.confirmNewPassword.errors.mustMatch">
                                                            Confirm New Password do not match</div>
                                                    </div>
                                                </div>

                                                <div class="col-md-12 mt-5 text-center">
                                                    <button type="submit"
                                                        class="btn btn-secondary  theme-btn-2 dropdown-toggle-no">Change Password
                                                    </button></div>



                                            </div>
                                        </form>

                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>


<app-footer-dashboard></app-footer-dashboard>